// Contextos de la carcasa: acciones globales (crear, buscar, abrir caso) y avisos emergentes.
import { createContext, useContext } from 'react';

export type TonoAviso = 'info' | 'exito' | 'error' | 'alerta';

export interface Aviso {
  id: number;
  texto: string;
  detalle?: string;
  tono: TonoAviso;
  regla?: string | null;
  accion?: { texto: string; alHacer: () => void };
}

export interface AccionesUi {
  abrirCrear: () => void;
  abrirPaleta: () => void;
  abrirAtajos: () => void;
  /** Abre el espacio de trabajo del caso (página completa). */
  abrirCaso: (caseId: string) => void;
  /** Vista rápida del caso en el panel lateral (?caso=) sin salir de la página actual. */
  abrirVistaRapida: (caseId: string) => void;
  cerrarCaso: () => void;
  avisar: (a: Omit<Aviso, 'id'>) => void;
}

export const ContextoUi = createContext<AccionesUi | null>(null);

export function useUi(): AccionesUi {
  const c = useContext(ContextoUi);
  if (!c) throw new Error('useUi debe usarse dentro de la carcasa');
  return c;
}

/** Evento del tablero o la lista para abrir el diálogo de creación con datos iniciales. */
export const EVENTO_RECIENTES = 'upk-innova:recientes';
